import { RemoteDeviceSvg } from '@/assets/icons/remote-device-svg';
import { useIsLiveRunningRemoteSession } from '@/hooks/desktop/useIsLiveRunningRemoteSession';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@heidi/design-system/tooltip';
import { FormattedMessage } from 'react-intl';

interface RemoteLiveRunningSessionIconProps {
  sessionId: string | null | undefined;
}

export function RemoteLiveRunningSessionIcon({
  sessionId,
}: RemoteLiveRunningSessionIconProps) {
  const isLiveRunning = useIsLiveRunningRemoteSession(sessionId);

  if (!isLiveRunning) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="relative inline-flex shrink-0 items-center"
            data-testid="sidebar-remote-live-session-icon"
          >
            <RemoteDeviceSvg className="size-3 text-text-secondary" />
            <span
              aria-hidden
              className="absolute -bottom-px -right-px size-1.5 rounded-full bg-entity-green ring-2 ring-surface"
            />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <FormattedMessage defaultMessage="Live on Remote" id="sRpA0X/Kzl" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
